module.exports = __webpack_public_path__ + "4eb0736e7ac234936acd607a2de0658b.png";